import React, { useContext } from "react";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { CircularProgress } from "@mui/material";
import { useAgreement } from "./hooks/useAgreement";

const AgreementContext = React.createContext();

export function useAgreementContext() {
  return useContext(AgreementContext);
}
export function AgreementProvider({ agreementId, children }) {
  const { setError } = useErrorMessage();
  const { agreement, loading, error } = useAgreement({
    agreementId: agreementId,
  });
  if (error) {
    setError(error);
  }

  if (loading || !agreement) {
    return <CircularProgress sx={{ alignSelf: "center" }} />;
  }
  return (
    <AgreementContext.Provider value={agreement}>
      {children}
    </AgreementContext.Provider>
  );
}
